<div class="w-full" style="min-height: 60vh">
  <span class="text-xl font-bold mb-3 block">Customización de Casino</span>
  <div class="mb-3">
    <span class="text-lg font-semibold block">Tema de Colores</span>
    <span class="text-sm mb-2"> Personaliza la apariencia de tu Casino </span>
  </div>
  <div>
    <app-section-theme-color
      (onChange)="onChangeTheme($event)"
      [showConfirmDialog]="showThemeConfirm"
      (onHideConfirmDialog)="showThemeConfirm = false"
    >
    </app-section-theme-color>
  </div>

  <div class="w-12rem flex">
    <p-button
      label="Guardar"
      class="mt-3 w-full"
      [disabled]="disabledTheme"
      (click)="save()"
    ></p-button>
  </div>
</div>
